<template>
	<div class="Income">
		<a-tabs v-model:activeKey="activeKey" type="card" @change="changes">
      <a-tab-pane key="1" tab="收益详情">
				<div class="main_title">
					<ul>
						<li>
							<span>开始时间</span>
							<a-date-picker placeholder="开始时间" :showToday=false v-model:value='consumeStartTime' style="margin-right:0;"/>
						</li>
						<li>
							<span>截止时间</span>
							<a-date-picker placeholder="截止时间" :showToday=false v-model:value='consumeEndTime' style="margin-right:0;"/>
						</li>
					</ul>
					<div class="main_title_right">
						<span class="wenzi">服务</span>
						<a-select v-model:value="services" @change="handleChange" style="width:120px;margin-right:30px;">
							<a-select-option value="">全部</a-select-option>
						</a-select>
						<span class="wenzi">条件</span>
						<a-select v-model:value="conditions" @change="handleChange2" style="width:120px;">
							<a-select-option value="">全部</a-select-option>
						</a-select>
						<a-input class="bgm" style="width:160px" placeholder="通过房间名或ID筛选" v-model:value="RoomValue" />
						<button @click="search({current:1,pageSize:paginationObj.pageSize})">查询</button>
					</div>
				</div>
				<a-table bordered :loading="tableloading" :columns="columns" :data-source="RoomData" :pagination="paginationObj" @change="search" :rowKey="(record,index)=>{return index}">
				</a-table>
      </a-tab-pane>
      <a-tab-pane key="2" tab="收益概览">
				<div class="main_title" style="margin-bottom:20px;padding-bottom:22px;border-bottom-left-radius:4px;border-bottom-right-radius:4px;">
					<ul>
						<li>
							<span>开始时间</span>
							<a-date-picker placeholder="开始时间" :showToday=false v-model:value='consumeStartTime2' style="margin-right:0;"/>
						</li>
						<li>
							<span>截止时间</span>
							<a-date-picker placeholder="截止时间" :showToday=false v-model:value='consumeEndTime2' style="margin-right:0;"/>
						</li>
					</ul>
					<div class="main_title_right">
						<span class="wenzi">服务</span>
						<a-select v-model:value="services2" @change="handleChange3" style="width:120px;margin-right:30px;">
							<a-select-option value="">全部</a-select-option>
              <a-select-option value="0">流量</a-select-option>
              <a-select-option value="1">容量</a-select-option>
              <a-select-option value="4">预付费直播间</a-select-option>
						</a-select>
						<span class="wenzi">条件</span>
						<a-select v-model:value="conditions2" @change="handleChange4" style="width:120px;">
              <a-select-option value="">全部</a-select-option>
              <a-select-option value="1">用户ID</a-select-option>
              <a-select-option value="2">注册电话</a-select-option>
						</a-select>
						<a-input class="bgm" style="width:160px" placeholder="通过房间名或ID筛选" v-model:value="RoomValue2" />
						<button @click="querychart()">查询</button>
					</div>
				</div>
				<div class="main_con">
					<div class="main_con_left">
            <a-tabs v-model:activeKey="activeKey2" @change="changes2" class="echartstabs">
              <a-tab-pane key="1">
                <template #tab>
                  <span class="tubiao">
                    <i class="iconfont icon-zhuzhuang" style="font-size: 14px;" />
                    柱状图
                  </span>
                </template>
                <div class="MyChart2" ref="MyChart2" style="width:auto;height:660px;"></div>
              </a-tab-pane>
              <a-tab-pane key="2">
                <template #tab>
                  <span class="tubiao">
                    <i class="iconfont icon-zhexian" style="font-size: 14px;" />
                    线图
                  </span>
                </template>
                <div class="MyChart3" ref="MyChart3" style="width:auto;height:660px;"></div>
              </a-tab-pane>
            </a-tabs>
          </div>
					<div class="main_con_right">
            <div class="MyChart" ref="MyChart" style="width:auto;height:660px;"></div>
          </div>
				</div>
      </a-tab-pane>
    </a-tabs>
	</div>
</template>
<script>
import { myMinxin } from "@/mixin"
import publics from '@/api/public'
import {queryProfitStatistics,queryProfitStatisticsDetail} from "@/api/api"
import {methodCallback} from '@/api/methodCallback'
import { message } from 'ant-design-vue';
export default {
  name: "Person",
  mixins: [myMinxin],
  data() {
    return {
      consumeStartTime: this.$moment(new Date().setMonth((new Date().getMonth() - 1))), //开始时间
      consumeEndTime: this.$moment(new Date()), //结束时间
      consumeStartTime2: this.$moment(new Date().setMonth((new Date().getMonth() - 1))), //开始时间
      consumeEndTime2: this.$moment(new Date()), //结束时间
      services: '', //详情服务下拉框
      conditions: '', //详情条件下拉框
      RoomValue: '', //详情输入框
      RoomValue2: '', //概念输入框
      services2: '', //概念服务下拉框
      conditions2: '', //概念条件下拉框
      RoomData: [],
      paginationObj: {
        hideOnSinglePage: true,
        pageSize: 10,
        pageIndex: 1,
        total: 0,
        size: "small",
      },
      columns:publics.columns3,
      tableloading: true,
      activeKey: '1',
      activeKey2: '1',
      myEchart: '',
      myEchart2: '',
      myEchart3: '',
      echartabs: '',
      option: {
        title: [{
          text: '产品消费分布 ',
          textStyle: {
            color: '#ffffff',
            fontSize: 14,
            fontWeight: "normal"
          },
          left: 30,
          top: 30
        }],
        tooltip: {
          trigger: 'item'
        },
        legend: {
          left: 'center',
          bottom: 20,
          textStyle: {
            color: '#FFFFFF',
          },
        },
        color:['#2A2ADC', '#FA9319', '#F75353','#73C0DE'],
        series: [
          {
            type: 'pie',
            radius: ['60%', '70%'],
            data: [
              { value: 0, name: '流量 ' },
              { value: 0, name: '容量' },
              { value: 0, name: '预付费直播间' },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      },
      option2: {
        backgroundColor: '#242526',
        grid:{
          top: 110,
          height:480
        },
        title: [{
          text: '收益趋势（单位：元）',
          textStyle: {
            color: '#ffffff',
            fontSize: 14,
            fontWeight: "normal"
          },
          left: 30,
          top: 30
        }],
        tooltip: {
          trigger: 'item',
        },
        legend: {
          right: 30,
          bottom: 20,
          itemGap: 40,
          textStyle: {
            color: '#FFFFFF',
          },
        },
        color:['#1877F2'],
        xAxis: {
          type: 'category',
          data: [],
          axisLabel: {
            show: true,
            textStyle: {
                color: '#fff'
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            show: true,
            textStyle: {
                color: '#fff'
            }
          }
        },
        series: [
          {
            data: [],
            type: 'bar'
          }
        ]
      },
      option3: {
        grid:{
          top: 110,
          height:480
        },
        title: [{
          text: '收益趋势（单位：元）',
          textStyle: {
            color: '#ffffff',
            fontSize: 14,
            fontWeight: "normal"
          },
          left: 30,
          top: 30
        }],
        tooltip: {
          trigger: 'item',
        },
        xAxis: {
          type: 'category',
          data: [],
          axisLabel: {
            show: true,
            textStyle: {
                color: '#fff'
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            show: true,
            textStyle: {
                color: '#fff'
            }
          }
        },
        series: [
          {
            data: [],
            type: 'line'
          }
        ]
      },
    }
  },
  watch: {

  },
  mounted() {
    if(this.activeKey == 2){
      this.querychart();
    }else{
      this.search({current:1,pageSize:this.paginationObj.pageSize});
    }
  },
  methods: {
    // 收益详情
    search(pagination){
      let startTime = this.$moment(this.consumeStartTime).startOf('day').format('YYYY-MM-DD HH:mm:ss');
      let endTime = this.$moment(this.consumeEndTime).endOf('day').format('YYYY-MM-DD HH:mm:ss');
      let cyl = this.$moment(this.consumeEndTime).diff(this.$moment(this.consumeStartTime), 'days')
      if(endTime < startTime){
        message.warn("结束时间应大于开始时间");
        return
      }
      if(cyl > 31){
        message.warn("时间跨度不能超过31天");
        return
      }
      let data = {
        pageIndex: pagination.current,
        PageSize: pagination.pageSize,
        startTime: startTime,
        endTime: endTime
      }
      if(this.services != ''){
        data = {...data,consumeType: this.services}
      }
      if(this.conditions == '1'){
        data = {...data,accountNO: this.RoomValue}
      }
      if(this.conditions == '2'){
        data = {...data,phone: this.RoomValue}
      }
      queryProfitStatisticsDetail(data)
        .then((res) => {
          if(res.data.code == "SUCCESS"){
            this.tableloading = false;
            this.RoomData = res.data.data.collections;
            this.paginationObj.total = res.data.data.total;
          }else{
            methodCallback(res);
          }
        })
        .catch((err) => {
          console.log(err)
        });
    },
    handleChange(){
      this.services = value
    },
    handleChange2(){
      this.conditions = value
    },
    initecharts() {
      this.myEchart = this.$echarts.init(this.$refs.MyChart, 'pie')
      this.myEchart.clear()
      this.myEchart.setOption(this.option)
    },
    initecharts2() {
      this.myEchart2 = this.$echarts.init(this.$refs.MyChart2, 'bar')
      this.myEchart2.clear()
      this.myEchart2.setOption(this.option2)
    },
    initecharts3() {
      this.myEchart3 = this.$echarts.init(this.$refs.MyChart3, 'light')
      this.myEchart3.clear()
      this.myEchart3.setOption(this.option3)
    },
    changes(activeKey){
      if(activeKey == 2){
        this.querychart();
        this.echartabs = 0
      }
    },
    changes2(activeKey){
      if(this.echartabs == 0){
        if(activeKey == 2){
          this.$nextTick(() => {
            this.echartabs = 1;
            this.initecharts3();
          });
        }
      }else{
        if(activeKey == 1){
          this.initecharts2();
        }else{
          this.initecharts3();
        }
      }
    },
    handleChange3(value){
      this.services2 = value
    },
    handleChange4(value){
      this.conditions2 = value
    },
    // 收益概览
    querychart(){
      let startTime = this.$moment(this.consumeStartTime2).startOf('day').format('YYYY-MM-DD HH:mm:ss');
      let endTime = this.$moment(this.consumeEndTime2).endOf('day').format('YYYY-MM-DD HH:mm:ss');
      let cyl = this.$moment(this.consumeEndTime2).diff(this.$moment(this.consumeStartTime2), 'days')
      if(endTime < startTime){
        message.warn("结束时间应大于开始时间");
      }else if(cyl > 31){
        message.warn("时间跨度不能超过31天");
      }else{
        let data = {
          startTime: startTime,
          endTime: endTime,
        }
        if(this.services2 != ''){
          data = {...data,consumeType: this.services2}
        }
        if(this.conditions2 == '1'){
          data = {...data,accountNO: this.RoomValue}
        }
        if(this.conditions2 == '2'){
          data = {...data,phone: this.RoomValue}
        }
        queryProfitStatistics(data)
          .then((res) => {
            if(res.data.code == "SUCCESS"){
                this.option2.xAxis.data = []
                this.option2.series[0].data = []
                this.option3.xAxis.data = []
                this.option3.series[0].data = []
              let arr = res.data.data.consumeTypeProfitStatisticsSummaryResultDTOS;
              arr.forEach((item) =>{
                if(item.consumeType == 0){
                  this.option.series[0].data[0].value = item.summaryAmount;
                }else if(item.consumeType == 1){
                  this.option.series[0].data[1].value = item.summaryAmount;
                }else if(item.consumeType == 4){
                  this.option.series[0].data[2].value = item.summaryAmount;
                }
              })
              this.initecharts();
              let srr = res.data.data.dayProfitStatisticsResultDTOS;
              srr.forEach((item) =>{
                this.option2.xAxis.data.push(item.day);
                this.option2.series[0].data.push(item.realAmount);
                this.option3.xAxis.data.push(item.day);
                this.option3.series[0].data.push(item.realAmount);
              })
              if(this.activeKey2 == 2){
                this.initecharts3();
              }else{
                this.initecharts2();
              }
            }else{
              methodCallback(res);
            }
          })
          .catch((err) => {
            console.log(err)
          });
      }
    },
  }
}
</script>
<style lang="less" scoped>
.Income{
  height: 100%;
  border-radius: 4px;
	/deep/ .ant-tabs-bar{
		margin: 0;
		height: 48px;
		border-bottom: 1px solid #3F3F3F;
		background: #242526;
		border-top-left-radius: 4px;
		border-top-right-radius: 4px;
		.ant-tabs-tab{
			color: #FFFFFF;
			font-size: 16px;
			padding: 0 30px;
			margin: 0;
			background: none;
			border: none;
			box-sizing: border-box;
			height: 48px;
			line-height: 48px;
		}
		.ant-tabs-nav-container{
			height: 48px;
		}
		.ant-tabs-ink-bar{
			visibility: visible;
			bottom: 0;
		}
		.ant-tabs-tab-active{
			color: #1877F2;
		}
	}
	.main_title {
    display: flex;
    justify-content: space-between;
    padding: 20px 30px 0 30px;
		background: #242526;
    /deep/ .ant-select-arrow {
      color: rgba(255, 255, 255, 0.6) !important;
    }
		.main_title_right{
			.wenzi{
				font-size: 14px;
				color: #FFFFFF;
				margin-right: 15px;
			}
			/deep/ .ant-select-selector {
				background: #181818 !important;
				border: 1px solid #3f3f3f !important;
				border-radius: 2px !important;
				color: rgba(255, 255, 255, 0.6);
			}
      .bgm{
        background: #181818 !important;
        border: 1px solid #3F3F3F !important;
        border-radius: 2px !important;
        color: rgba(255, 255, 255, .6);
        margin: 0 20px;
      }
			button {
				width: 80px;
				height: 30px;
				background: #1877f2;
				border: none;
				border-radius: 2px;
				cursor: pointer;
				color: #FFF;
			}
		}
    ul {
      display: flex;
      li {
        margin-right: 30px;
        color: #ffffff;
        span {
          margin-right: 20px;
					font-size: 14px;
        }
        /deep/ .ant-input {
          width: 120px;
          height: 30px;
          border: 1px solid #626262;
          background: #181818;
          color: #ffffff;
          font-size: 14px;
        }
      }
    }
  }
	.main_con{
		display: flex;
		justify-content: space-between;
		.main_con_left{
			width: 49.6%;
			height: 660px;
			background: #242526;
      .echartstabs{
        /deep/ .ant-tabs-bar{
          position: absolute;
          z-index: 99;
          right: 0;
          top: 30px;
          border-bottom: none;
        }
        /deep/ .ant-tabs-tab{
          padding: 0;
          height: 20px;
          line-height: 20px;
          margin: 0 30px 0 0;
        }
        /deep/ .ant-tabs-ink-bar{
          display: none !important;
        }
      }
      .tubiao{
        display: flex;
        align-items: flex-end;
        i{
          margin-right: 5px;
        }
      }
		}
		.main_con_right{
			width: 49.6%;
			height: 660px;
			background: #242526;
		}
	}
	/deep/ .ant-table-placeholder {
		background: #181818;
		border: 1px solid #242526;
		box-sizing: border-box;
	}
	/deep/ .ant-table{
		background: #242526;
	}
	/deep/ .ant-table-wrapper{
		box-sizing: border-box;
		padding: 20px 30px;
		background: #242526;
		border-bottom-left-radius: 4px;
		border-bottom-right-radius: 4px;
		.ant-table-content{
			border-radius: 6px;
			overflow: hidden;
		}
		.ant-table-bordered .ant-table-thead > tr > th,
		.ant-table-bordered .ant-table-tbody > tr > td {
			border-right: 1px solid #242526;
		}
		.ant-table-thead > tr > th{
			border-bottom: 1px solid #242526;
		}
		.ant-table-bordered .ant-table-header > table,
		.ant-table-bordered .ant-table-body > table,
		.ant-table-bordered .ant-table-fixed-left table,
		.ant-table-bordered .ant-table-fixed-right table {
			border: 1px solid #242526;
			border-right: 0;
			border-bottom: 0;
		}
		.ant-table-body {
			table {
				background: #181818;
				.ant-table-align-center {
					background: rgba(10, 10, 10, .8);
					color: #fff;
					padding: 3px;
					font-size: 14px;
				}
				.ant-table-tbody > tr:hover:not(.ant-table-expanded-row) > td {
					background: #181818 !important;
				}
				.ant-table-row {
					color: #fff;
					td {
						padding: 8px;
						background: #181818;
						border-bottom: 1px solid #242526;
						.ant-input-affix-wrapper{
							.ant-input{
								background: #181818!important;
								color: #FFF;
								text-align: center;
								border: none;
							}
						}
					}
				}
			}
		}
	}

}
</style>
